module.exports = __webpack_public_path__ + "static/img/RSG2-24V10A_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSG2-24V10A_1.png
// module id = SuDn
// module chunks = 0